import { ARCHIVED_ALERTS_TABLE_COLUMNS } from "./AlertOccurenceTableColumns";
import { PaginatedTable } from "components/Table/Table";

import { AlertOccurrenceActioned } from "interfaces/alert";

import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export interface ArchivedAlertsTableProps {
  loading: boolean;
  error: boolean;
  count: number;
  pageIndex: number;
  pageSize: number;
  alertOccurrences: AlertOccurrenceActioned[];
  selectedAlert: AlertOccurrenceActioned;
  sortBy: number[];
  onUpdatePageSize: (pageSize: number) => void;
  onSelectAlert: () => void;
  onChangeSortBy: () => void;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
}

export const ArchivedAlertsTable = ({
  loading,
  pageIndex,
  pageSize,
  count,
  alertOccurrences,
  selectedAlert,
  onUpdatePageSize,
  onSelectAlert,
  onChangeSortBy,
  onPageChange
}: ArchivedAlertsTableProps): JSX.Element => {
  return (
    <SiteTableScroll elevation={0}>
      <PaginatedTable
        data={alertOccurrences}
        columns={ARCHIVED_ALERTS_TABLE_COLUMNS}
        loading={loading}
        dataQa="archived-alerts-table"
        count={count}
        page={pageIndex}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onSortingChange={onChangeSortBy}
        onPageSizeChange={(
          event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
        ) => onUpdatePageSize(parseInt(event.target.value))}
        onClickRow={onSelectAlert}
        isRowSelected={alert => selectedAlert && alert.id === selectedAlert.id}
      />
    </SiteTableScroll>
  );
};

const SiteTableScroll = styled(Paper)`
  display: flex;
  flex-flow: column nowrap;
  overflow-y: auto;
  flex-grow: 1;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 4px;
`;
